// extracted by mini-css-extract-plugin
export var bordertop = "ParagraphContactBlock-module--bordertop--e7fc5";
export var content = "ParagraphContactBlock-module--content--2fd54";
export var icon = "ParagraphContactBlock-module--icon--1d204";
export var paragraphcontactblockinner = "ParagraphContactBlock-module--paragraphcontactblockinner--89e7b";
export var paragraphcontactblockouter = "ParagraphContactBlock-module--paragraphcontactblockouter--b7ee7";
export var sharewrapper = "ParagraphContactBlock-module--sharewrapper--7fc7e";
export var title = "ParagraphContactBlock-module--title--1281c";
export var url = "ParagraphContactBlock-module--url--22d2e";